module.exports = __webpack_public_path__ + "static/img/game-logo-ebet.cb23dd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build922/assets/image/gamelogo/game-logo-ebet.png
// module id = KRXR
// module chunks = 0 1 2 3 4 5 6